const LAZYLOAD_OPTIONS = {
	elements_selector: '.lazy',
	use_native: true,
	threshold: 1000,
	callback_loaded: (el) => {
		el.closest('.image-wrapper')?.classList.add('image-loaded')
	},
}

const initLazyLoad = () => {
	window.require(['vendor.lazyload'], (LazyLoad) => {
		yTos.Cartier.Lazyload = new LazyLoad(LAZYLOAD_OPTIONS)

		yTos.notify(`CAR::Lazyload::Initialized`)
	})
}

const setLazyloadF31Configuration = () => {
	yTos.configuration.ui = {
		...yTos.configuration.ui,
		...{
			lazyload: {
				elements_selector: '.lazy-disabled',
			},
		},
	}
}

export { initLazyLoad, setLazyloadF31Configuration }
